import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/*
 * Description:
 *	- Component that display the description for design section
 */
export function Description({description}) {
  return <p className={style.designView_left_description}>{description}</p>;
}

Description.propTypes = {
  /*
   * Description string for design section
   */
  description: PropTypes.string.isRequired,
};

Description.defaultProps = {
  description: '',
};
